import moment from 'moment';
import 'moment/locale/pt-br';

export const getAbbreviatedMonthInPtbr = (data) => {
  const dataMoment = moment(data).locale('pt-BR');
  return dataMoment.format('MMM');
};
